export default __webpack_public_path__ + "static/media/acc.fa47620c.svg";